import React from "react";
import {Checkbox, ControlLabel, FormControl} from "react-bootstrap";
import Select from "react-select";

export default ({type, name, required, label, placeholder, disabled, options, value, onChange, skipLabel, ...props}) => {
    if ('checkbox' === type) {
        return (
            <Checkbox
                name={name}
                required={required}
                checked={value || false}
                onChange={(e) => onChange(e.target.checked)}
                disabled={disabled}
                {...props}
            >{!skipLabel && label}</Checkbox>
        );
    }

    if ('select' === type) {
        return (
            <>            
                {!skipLabel && <ControlLabel htmlFor={name}>{label}</ControlLabel>}
                <Select
                    name={name}
                    value={options.find((option) => option.value === value)}
                    onChange={({value}) => onChange(value)}
                    options={options}
                    isDisabled={disabled}
                    {...props}
                />
            </>
        );
    }

    return (
        <>
            {!skipLabel && <ControlLabel htmlFor={name}>{label}</ControlLabel>}
            <FormControl
                type={type}
                name={name}
                required={required}
                placeholder={placeholder}
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
                {...props}
            />
        </>
    );
}
